import { EpimsBaseEntityDto } from './epim-base.dto';

export class BankingStatusDto extends EpimsBaseEntityDto {

    id: string;
    BankingStatusName: string;
    SubscriptionUserId: string;
    SubscriberId: string;
    dateCreated: Date;
    dateUpdated?: Date;
    CreatedById: string;
    ModifiedById: string;
    SiteId: string;
    Version: number;
}